import { useQuery } from 'react-query';
import { LimitedSchemaQueryOptions } from '@frontend/react-query-helpers';
import { SchemaTaskCenterV2 } from '../../service';
import { IO } from '../../types';
import { getTaskByIdQueryData } from '../../utils';
import { defaultOptions } from '../config';

/**
 * Get task details by it's ID.
 */
export const useGetTaskById = <E = unknown, T = IO.GetTaskById['output']>(
  { locationIds, taskId }: IO.GetTaskById['input'],
  options?: LimitedSchemaQueryOptions<IO.GetTaskById, E, T>
) => {
  const { queryKey, requestParams } = getTaskByIdQueryData(locationIds, taskId);

  const query = useQuery({
    queryKey,
    queryFn: () => SchemaTaskCenterV2.ListTasksV2(requestParams),
    ...defaultOptions,
    ...options,
    enabled: !!taskId,
  });

  return {
    ...query,
    queryKey,
  };
};
